module.exports = __webpack_public_path__ + "static/media/YM46_5.060e9197.jpg";